<template lang="html">
  <div class="password-reset text-center">

    <!-- Select code method Form -->
    <form  v-if="!waitingCode"
           @submit.prevent="submit"
           class="form-group">

      <!-- Radio buttons  -->
      <div class="d-flex justify-content-around justify-content-sm-center">
        <div class="phone-type mr-sm-3">
          <label class="phone-type-label" for="mobile">
            <font-awesome-icon class="phone-type-icon mr-1" :icon="[ 'fas', 'mobile' ]" />
            SMS
          </label>
          <input id="mobile"
                 type="radio"
                 class="phone-type-radio"
                 @input="changePhoneType"
                 v-model="phoneType"
                 value="mobile">
        </div>
        <div class="phone-type ml-sm-3">
          <label class="phone-type-label" for="landLine">
            <font-awesome-icon class="phone-type-icon mr-1" :icon="[ 'fas', 'phone' ]" />
            Llamada
          </label>
          <input id="landLine"
                 type="radio"
                 class="phone-type-radio"
                 @input="changePhoneType"
                 v-model="phoneType"
                 value="land_line">
        </div>
      </div>

      <!-- Email input -->
      <!-- <label for="">Escribí el correo electrónico de la cuenta a recuperar:</label>-->
      <input
        v-model="email"
        @focus="cleanErrors"
        @keypress.enter.prevent="submit"
        class="form-control mt-3"
        type="email"
        placeholder="ejemplo@gmail.com"
        required
      >

      <!-- Error messages -->
      <div v-if="showError" class="error">
        <ul style="list-style-type:none; padding-inline-start: 0;">
          <li v-for="(error,index) in errorMessages" :key="`error-${index}`">
            <ul style="list-style-type:none; padding-inline-start: 0;">
              <li v-for="(message,index) in error" :key="`message-${index}`">
                {{message}}
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <!-- Submit buttons -->
      <div class="mt-3 w-100 text-center">
        <SquaredButton
          @click="$emit('close')"
          type="button"
          styleType="default"
          noUpperCase
          label="Cancelar" />
        <SquaredButton
          :isWaiting="isFetching"
          :disabled="email.length < 5 || isFetching"
          type="submit"
          styleType="primary"
          noUpperCase
          label="Enviar" />
      </div>

    </form>

    <!-- Password change Form -->
    <form @submit.prevent="sendNewPassword" v-else class="form-group text-center mb-0">
      <label class="w-100 text-left" for="code">
        Colocá el código que te enviamos por {{ isMobile ? 'SMS' : 'mensaje de voz' }} al número de teléfono *******<strong>{{phone}}</strong>
<!--        <a href="#" @click.prevent="editPhone">(corregir)</a>-->
      </label>

      <!-- Code input -->
      <label class="w-100 text-left" for="code">Código recibido</label>
      <input
        v-model="code"
        id="code"
        @input="cleanErrors"
        @focus="cleanErrors"
        @keypress.enter.prevent="sendNewPassword"
        class="form-control mb-3 code-input"
        type="text"
        maxlength="6"
        inputmode="numeric"
        pattern="\d{6,6}"
      >

      <!-- New password input -->
      <label class="w-100 text-left" for="password">Nueva clave</label>
      <input
        v-model="newPassword"
        id="password"
        @input="cleanErrors"
        @focus="cleanErrors"
        @keypress.enter.prevent="sendNewPassword"
        class="form-control mb-3"
        type="password"
        autocomplete="new-password">

      <!-- Error messages -->
      <div v-if="showError" class="error">
        <ul style="list-style-type:none; padding-inline-start: 0;">
          <li v-for="(error, index) in errorMessages" :key="`error-${index}`">
            <ul style="list-style-type:none; padding-inline-start: 0;">
              <li v-for="(message, index) in error" :key="`message-${index}`">
                {{message}}
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <p class="mb-3">El mensaje puede tardar hasta un minuto en llegarte.</p>

      <!-- Submit button -->
      <div class="my-2 mx-auto text-center" style="max-width: 60%">
        <SquaredButton
          :isWaiting="isFetching"
          :disabled="!code || isFetching"
          type="submit"
          styleType="primaryLargeBlock"
          noUpperCase
          label="Cambiar clave" />
      </div>

      <!-- Resend code button -->
      <div class="text-center">
        <button :disabled="count > 0 || isFetching"
                type="button"
                @click="resendCode"
                class="btn btn-link pr-0 align-baseline">
          Reenviar código
        </button>
        <span v-if="count > 0">{{ count ? ` (${count}s)` : '' }}</span>
      </div>

    </form>
  </div>
</template>

<script>
import store from '@/store'
import userUtilsMixin from '@/mixins/userUtils'
import {instance as snack} from '@/components/layout/SnackMessage'

export default {
  mixins: [
    userUtilsMixin
  ],

  props: {
    then: Function,
    props: Object
  },

  data: () => ({
    email: '',
    code: '',
    newPassword: '',
    isFetching: false,
    waitingCode: false,
    showError: false,
    errorMessages: {},
    phoneType: 'mobile',
    phone: '',
  }),

  computed: {
    count () { return this.userUtilsCount },

    isCommerce: () => store.getters['user/isCommerce'],

    isMobile () { return this.phoneType === 'mobile' }
  },

  methods: {

    changePhoneType () {
      if (this.showError)
        this.showError = false
    },

    submit () {
      if (this.showError) this.showError = false
      this.errorMessages = {}
      this.isFetching = true
      return store.dispatch('user/sendRecoveryCode', {email: this.email, type: this.phoneType})
        .then(res => {
          this.waitingCode = true
          // activate countdown
          this.userUtilsCount = 60
          this.userUtilsCountdown()
          this.phone = res.phone
        })
        .catch(er => {
          const messages = er.response && er.response.data && er.response.data.error &&
            er.response.data.error.message && er.response.data.error.message.errors
          if (messages) {
            this.errorMessages = messages
          }
          this.showError = true
        })
        .finally(() => { this.isFetching = false })
    },

    resendCode () {
      return this.submit()
    },

    sendNewPassword () {
      const code = this.code
      const password = this.newPassword
      this.isFetching = true

      return store.dispatch('user/sendNewPassword', {code, password})
        .then(res => {
          this.$emit('close')

          snack({
            title: 'Nueva contraseña',
            text: `Cambiaste tu contraseña correctamente.`,
          })
        })
        .catch(er => {
          const messages = er.response && er.response.data && er.response.data.error &&
            er.response.data.error.message && er.response.data.error.message.errors
          if (messages) {
            this.errorMessages = messages
          }
          this.showError = true
        })
        .finally(() => { this.isFetching = false })
    },

    cleanErrors () {
      this.showError = false
      this.errorMessage = {}
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/colors';

.password-reset {
  & .error {
    display: block;
    color: var(--danger);
    text-align: center;
    padding-top: 0.5rem;
    padding-bottom: 0;
    margin-right: auto;
    margin-left: auto;
    max-width: 320px;
  }
}

.phone-type {
  &-label {
    padding: 8px 4px;
    cursor: pointer;
    margin: 0;
  }

  &-radio {
    cursor: pointer;
    &:checked {
      opacity: 0.75;
    }
  }

  &-icon {
    color: $primary;
  }
}

.code-input {
  letter-spacing: 1rem;
  text-align: center;
  &:valid {
    font-weight: bold;
  }

}


</style>



// WEBPACK FOOTER //
// src/components/user/CodeForm.vue